module.exports = __webpack_public_path__ + "img/collaborator.45480bb3.svg";